<div class="container scroll-container">
    <div><h3 jhiTranslate="field-manager.study-instances.title"></h3></div>
    <!-- Grouped Tables -->
    <jhi-study-instances-filter-select (filterChanged)="onAssignedFilterChanged($event)"
                                       #assignedFilter></jhi-study-instances-filter-select>
    <cdk-virtual-scroll-viewport
            [itemSize]="9"
            class="virtual-scroll-viewport custom-scroll-style"
            (scrolledIndexChange)="onScrollAssigned($event)" #virtualScrollViewportAssigned>

        <div class="rounded-table">
            <table class="table table-hover mb-0">
                <thead class="thead-light">
                <tr>
                    <th scope="col" class="border-0" style="width: 10%" jhiTranslate="field-manager.plot-details.column.crop">Crop</th>
                    <th scope="col" class="border-0" style="width: 10%" jhiTranslate="field-manager.plot-details.column.environment.no">Environment No</th>
                    <th scope="col" class="border-0" style="width: 20%" jhiTranslate="field-manager.study-instances.column.location">Location Name</th>
                    <th scope="col" class="border-0 text-center" style="width: 5%" jhiTranslate="field-manager.study-instances.column.entries"># Entries</th>
                    <th scope="col" class="border-0 text-center" style="width: 5%" jhiTranslate="field-manager.study-instances.column.reps"># Reps</th>
                    <th scope="col" class="border-0 text-center" style="width: 5%" jhiTranslate="field-manager.study-instances.column.plots"># Plots</th>
                    <th scope="col" class="border-0 text-center" style="width: 5%" jhiTranslate="field-manager.study-instances.column.ranges"># Ranges</th>
                    <th scope="col" class="border-0 text-center" style="width: 5%" jhiTranslate="field-manager.study-instances.column.cols"># Cols</th>
                    <th scope="col" class="border-0 text-center" style="width: 30%" jhiTranslate="field-manager.study-instances.column.actions">Actions</th>
                </tr>
                </thead>
                <tbody>

                <ng-container *cdkVirtualFor="let instance of flattenedData; trackBy: trackByInstance">
                    <!-- Group Header -->
                    <tr *ngIf="instance.header" class="border-0">
                        <td colspan="9" class="study-item">
                            <div class="flex items-center space-x-2">
                                <span class="text-blue-600">{{ instance.programName }}</span>
                                <span class="text-gray-400">&nbsp;<i class="fa fa-long-arrow-right"></i>&nbsp;</span>
                                <span class="text-gray-600">{{ instance.studyName }}</span>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="!instance.header" class="instance-item" [class.selected]="isStudySelected(instance.data)"
                        (click)="loadStudy(instance.data)">
                        <td class="instance-item-td"
                            [class.selected]="isStudySelected(instance.data)">{{ instance.data.crop }}
                        </td>
                        <td>{{ instance.data.instanceNumber }}</td>
                        <td>
                            <div class="text-truncate" [title]="instance.data.locationName" style="max-width: 100px;">
                                {{ instance.data.locationName }}
                            </div>
                        </td>
                        <td class="text-center">{{ instance.data.entriesCount }}</td>
                        <td class="text-center">{{ instance.data.replicatesCount }}</td>
                        <td class="text-center">{{ instance.data.plotsCount }}</td>
                        <td class="text-center">{{ instance.data.rangeCount }}</td>
                        <td class="text-center">{{ instance.data.columnCount }}</td>
                        <td>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-outline-primary btn-sm mx-1"
                                        (click)="unAssignStudyFromBlock(instance.data, $event)"
                                        [disabled]="isButtonDisabled()"
                                        title="{{ 'field-manager.remove.study.instance.title' | translate }}"><i
                                        class="fa fa-minus"></i> {{'field-manager.study-instances.button.unassign' | translate}}
                                </button>
                                <button class="btn btn-outline-secondary btn-sm mx-1"
                                        (click)="editStudy(instance.data, $event)"
                                        [disabled]="isButtonDisabled()"
                                        title="{{ 'field-manager.edit.plots.title' | translate}}"><i class="fa fa-edit"></i>
                                </button>
                                <button *ngIf="!isStudyVisible(instance.data)"
                                        [disabled]="isButtonDisabled()"
                                        (click)="toggeVisibility(instance.data,'SHOW', $event)"
                                        class="btn btn-outline-secondary btn-sm mx-1"
                                        title="{{ 'field-manager.show.study.title' | translate }}"><i
                                        class="fa fa-eye"></i></button>
                                <button *ngIf="isStudyVisible(instance.data)" [disabled]="isButtonDisabled()"
                                        (click)="toggeVisibility(instance.data,'HIDE', $event)"
                                        class="btn btn-outline-secondary btn-sm mx-1"
                                        title="{{ 'field-manager.hide.study.title' | translate }}"><i
                                        class="fa fa-eye-slash"></i></button>
                            </div>
                        </td>
                    </tr>
                </ng-container>
                </tbody>
            </table>
        </div>
        <div *ngIf="loadingAssigned" class="row">
            <div class="row h-100 w-100">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <div class="alert alert-light border shadow-sm p-4 text-center my-4">
                        <span class="throbber"></span>
                        <p class="text-muted mb-3">Loading...</p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="(!flattenedData || flattenedData.length === 0) && !loadingAssigned" class="row">
            <div class="row h-100 w-100">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <div class="alert alert-light border shadow-sm p-4 text-center my-4">
                        <i class="fas fa-filter-circle-xmark text-primary fs-2 mb-3 d-block"></i>
                        <h5 class="text-dark mb-3" jhiTranslate="field-manager.study-instances.no.results">No Results Found</h5>
                        <p class="text-muted mb-3" jhiTranslate="field-manager.study-instances.no.matching.records">No matching records found in the database</p>
                        <button class="btn btn-outline-primary btn-sm" (click)="clearFilterAssigned()">
                            <i class="fas fa-rotate me-1"></i>{{ 'field-manager.study-instances.clear.filters' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</div>

<!-- Bottom Section -->
<div class="container scroll-container divider">
    <div><h3 jhiTranslate="field-manager.study-instances.title.pending"></h3></div>
    <!-- Grouped Tables -->
    <jhi-study-instances-filter-select (filterChanged)="onPendingFilterChanged($event)"
                                       #pendingFilter></jhi-study-instances-filter-select>
    <cdk-virtual-scroll-viewport
            [itemSize]="20"
            class="virtual-scroll-viewport custom-scroll-style"
            (scrolledIndexChange)="onScrollUnassigned($event)" #virtualScrollViewportUnassigned>
        <!-- Study Groups within Program -->
        <div *ngIf="(unassignedInstances$ | async).length > 0"
             class="rounded-table">
            <div class="table-responsive">
                <table class="table table-hover mb-0">
                    <thead class="thead-light">
                    <tr>
                        <th scope="col" class="border-0" style="width: 10%"jhiTranslate="field-manager.plot-details.column.crop">Crop</th>
                        <th scope="col" class="border-0" style="width: 15%"jhiTranslate="field-manager.plot-details.column.program">Program</th>
                        <th scope="col" class="border-0" style="width: 30%"jhiTranslate="field-manager.study-instances.column.study.name">Study Name</th>
                        <th scope="col" class="border-0" style="width: 15%"jhiTranslate="field-manager.plot-details.column.environment.no">Environment No</th>
                        <th scope="col" class="border-0" style="width: 15%"jhiTranslate="field-manager.study-instances.column.location">Location Name</th>
                        <th scope="col" class="border-0 text-center" style="width: 5%"jhiTranslate="field-manager.study-instances.column.ranges"># Ranges</th>
                        <th scope="col" class="border-0 text-center" style="width: 10%"jhiTranslate="field-manager.study-instances.column.actions">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let instance of unassignedInstances$ | async; trackBy: trackByInstance">
                        <tr >
                            <td>{{ instance.crop }}</td>
                            <td>
                                <div class="text-truncate" [title]="instance.programName" style="max-width: 100px;">
                                    {{ instance.programName }}
                                </div>
                            </td>
                            <td>
                                <div class="text-truncate" [title]="instance.studyName" style="max-width: 200px;">
                                    {{ instance.studyName }}
                                </div>
                            </td>
                            <td>{{ instance.instanceNumber }}</td>
                            <td>
                                <div class="text-truncate" [title]="instance.locationName" style="max-width: 100px;">
                                    {{ instance.locationName }}
                                </div>
                            </td>
                            <td class="text-center">{{ instance.rangeCount }}</td>
                            <td>
                                <div class="d-flex justify-content-center">
                                    <button class="btn btn-outline-primary btn-sm"
                                            (click)="assignStudyToBlock(instance, $event)"
                                            [disabled]="isButtonDisabled()"
                                            title="{{ 'field-manager.assign.study.instances.title' | translate }}"><i
                                            class="fa fa-plus"></i>
                                        {{'field-manager.study-instances.button.assign' | translate}}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container >
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngIf="loadingUnassigned" class="row">
            <div class="row h-100 w-100">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <div class="alert alert-light border shadow-sm p-4 text-center my-4">
                        <span class="throbber"></span>
                        <p class="text-muted mb-3" jhiTranslate="field-manager.action.loading"></p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="(unassignedInstances$ | async).length === 0 && !loadingUnassigned" class="row">
            <div class="row h-100 w-100">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <div class="alert alert-light border shadow-sm p-4 text-center my-4">
                        <i class="fas fa-filter-circle-xmark text-primary fs-2 mb-3 d-block"></i>
                        <h5 class="text-dark mb-3" jhiTranslate="field-manager.study-instances.no.results"></h5>
                        <p class="text-muted mb-3" jhiTranslate="field-manager.study-instances.no.matching.records">No matching records found in the database</p>
                        <button class="btn btn-outline-primary btn-sm" (click)="clearFilterUnAssigned()">
                            <i class="fas fa-rotate me-1"></i>{{ 'field-manager.study-instances.clear.filters' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>

</div>
